<template>
  <BaseDataList
    ref="dataList"
    :items="contactRequests"
    :service="fetchContactRequests"
    allow-search
    allow-filters
    allow-export
    :export-service="exportContactRequests"
    :filename="exportFilename"
  >
    <template #header>
      <ContactRequestListHeader />
    </template>

    <template #filters="{ action, filter }">
      <Filters :action="action" :filters="filter" />
    </template>

    <template #active-filters="{ action, filter }">
      <ActiveFilterList :action="action" :filters="filter" />
    </template>

    <template #default="{ item }">
      <ContactRequestListItem :contact-request="item" />
    </template>
  </BaseDataList>
</template>

<script>
import { snakeCase } from 'lodash-es';
import { projectContactRequestsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import Filters from './filters.vue';
import ActiveFilterList from './active-filter-list.vue';
import ContactRequestListHeader from './contact-request-list-header.vue';
import ContactRequestListItem from './contact-request-list-item.vue';

export default {
  components: {
    Filters,
    ActiveFilterList,
    ContactRequestListHeader,
    ContactRequestListItem,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lastQuery: {},
      contactRequests: [],
    };
  },
  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId];
    },
    exportFilename() {
      return snakeCase(`${this?.project?.name || 'project'}_contact_requests`);
    },
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    async fetchContactRequests(query = {}) {
      try {
        const response = await projectContactRequestsClient.list(this.projectId, {
          ...query,
          include: 'pipelineStage',
        });

        this.contactRequests = mapKeysToCamelCase(response.data, true);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async exportContactRequests(query = {}) {
      try {
        const response = await projectContactRequestsClient.list(
          this.projectId,
          {
            ...query,
            export: true,
          },
          {
            responseType: 'blob',
          }
        );

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
